import React from "react";

import {
  Button,
  Select,
  SelectData,
  Typography,
} from "@king-ict/eupisi-ui/components";
import { nameof } from "@king-ict/eupisi-ui/utils";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { useGetGroupInstitutions } from "../../hooks/codebook/useGetGroupInstitutions";
import { useGetInstitutionProgramAges } from "../../hooks/codebook/useGetProgramAges";
import { useGetInstitutionProgramDurations } from "../../hooks/codebook/useGetProgramDurations";
import { useGetInstitutionPrograms } from "../../hooks/codebook/useGetPrograms";
import useInput from "../../hooks/input/useInput";
import { RequestInstitutionProgramFilters } from "../../models/Institution/InstitutionProgramSearch";
import CodeBook from "../../models/Shared/CodeBook";
import style from "./InstitutionLocationsAndProgramsFilters.module.scss";

interface Props {
  handleSearch: any;
  setFilters: (
    value: React.SetStateAction<RequestInstitutionProgramFilters>
  ) => void;
  filters: RequestInstitutionProgramFilters;
  handleClear?: () => void;
  pedagogicalYearInstitutionId: number;
}

export const InstitutionLocationsAndProgramsFilters: React.FC<Props> = ({
  handleSearch,
  setFilters,
  filters,
  handleClear = () => {
    setFilters({} as RequestInstitutionProgramFilters);
  },
  pedagogicalYearInstitutionId,
}) => {
  const { t } = useTranslation();

  const programs = useGetInstitutionPrograms(pedagogicalYearInstitutionId);
  const programAges = useGetInstitutionProgramAges(
    pedagogicalYearInstitutionId
  );

  const groupInstitutions = useGetGroupInstitutions(
    pedagogicalYearInstitutionId
  );

  const programDurations = useGetInstitutionProgramDurations(
    pedagogicalYearInstitutionId
  );

  const { handleChange } = useInput();

  return (
    <>
      <Row>
        <Col md={12}>
          <Typography variant="smallHeading">
            {t("common.filtersChoice")}
          </Typography>
        </Col>
      </Row>
      <Row className={style.filterRow}>
        <Col md={12}>
          <Select
            label={"Institucije"}
            name={nameof<typeof filters>("parentIntitutionId")}
            value={filters.parentIntitutionId}
            onChange={(e) => handleChange(e, setFilters)}
            emptyOption={{ value: undefined, text: "" }}
            selectData={
              {
                valueProp: "id",
                textProp: "name",
                data: groupInstitutions || [],
              } as SelectData<CodeBook>
            }
          />
        </Col>
      </Row>
      <Row className={style.filterRow}>
        <Col md={6}>
          <Select
            label={t("common.programAge")}
            name={nameof<typeof filters>("programAgeId")}
            value={filters.programAgeId}
            onChange={(e) => handleChange(e, setFilters)}
            emptyOption={{ value: undefined, text: "" }}
            selectData={
              {
                valueProp: "id",
                textProp: "name",
                data: programAges || [],
              } as SelectData<CodeBook>
            }
          />
        </Col>
        <Col md={6}>
          <Select
            label={t("common.programDuration")}
            name={nameof<typeof filters>("programDurationId")}
            value={filters.programDurationId}
            onChange={(e) => handleChange(e, setFilters)}
            emptyOption={{ value: undefined, text: "" }}
            selectData={
              {
                valueProp: "id",
                textProp: "name",
                data: programDurations || [],
              } as SelectData<CodeBook>
            }
          />
        </Col>
      </Row>
      <Row className={style.lastFilterRow}>
        <Col md={6}>
          <Select
            label={t("common.program")}
            name={nameof<typeof filters>("programId")}
            value={filters.programId}
            onChange={(e) => handleChange(e, setFilters)}
            emptyOption={{ value: undefined, text: "" }}
            selectData={
              {
                valueProp: "id",
                textProp: "name",
                data: programs || [],
              } as SelectData<CodeBook>
            }
          />
        </Col>
        <Col md={6} className={style.searchButtonsColumn}>
          <div className={style.searchButtons}>
            <Button color="primary" onClick={handleSearch}>
              {t("common.search")}
            </Button>
            <Typography color="primary" onClick={handleClear}>
              {t("common.cleanFilters")}
            </Typography>
          </div>
        </Col>
      </Row>
    </>
  );
};
